import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_RESHAB_SHIFTS_REQUEST',
  'GET_RESHAB_SHIFTS_SUCCESS',
  'GET_RESHAB_SHIFTS_ERROR'
);
